
import {
  elementOpen,
  elementVoid,
  elementClose,
  text,
  skipNode
} from 'incremental-dom';

export default function (className, elId) {
  var el = elementOpen('div', elId, ['class', [className, 'svg-wrapper', elId].join(' '), 'style', 'overflow: hidden;']);
  el.innerHTML = '<svg viewBox="0 0 60 48.5">  <title>WebPageTestIcon</title>  <path d="M30.54,2.42c-14.86,0-27,13.87-27,30.92a34.69,34.69,0,0,0,1.06,8.6L7,41.35a32.78,32.78,0,0,1-1-8c0-.71,0-1.41.07-2.11h8.08v-3H6.43a30.25,30.25,0,0,1,6.1-14.18L18,19.54l2.11-2.11-5.61-5.61A22.71,22.71,0,0,1,29,4.91v8.22h3V4.91a22.74,22.74,0,0,1,14.54,6.9L41,17.42l2.11,2.11L48.55,14a30.36,30.36,0,0,1,6.1,14.18H46.91v3H55c0,.7.07,1.4.07,2.11a33.27,33.27,0,0,1-1,8l2.36.59a35.41,35.41,0,0,0,1-8.57C57.49,16.29,45.4,2.42,30.54,2.42Z" style="fill: #151741"/>  <path d="M34.53,29.73a4,4,0,1,0-1.28,2.91l15.94,7.82,1.25-2.55L34.49,30.13C34.5,30,34.53,29.85,34.53,29.73Z" style="fill: #151741"/></svg>';
  skipNode(); // Don't clear out children
elementClose('div');
return el;
};